import { observer } from 'mobx-react';
import { useStore } from '../../state/MobxContext';
import Box from '@mui/material/Box';
// import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import CloverleafImage from '../Main/image/Cloverleaf.png';
import DialogContent from '@mui/material/DialogContent';
// import { useNavigate } from 'react-router-dom';
import DImage from "../Main/image/Icon256.png";
// import { TextField } from '@mui/material';
// import InputAdornment from "@mui/material/InputAdornment";
import { makeStyles, useMediaQuery } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
// import LockImage from '../Main/image/lock.png';
import Blind from '../Main/image/blind.png';
import PmgImage from '../Main/image/Pmg_big.png';
import CagImage from '../Main/image/cag_big.png';
import GolfImage from '../Main/image/GP_big.jpg';//골프
import EthImage from '../Main/image/2089411.png';
import UserImage from '../Main/image/User.png';
// import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import Grid from "@mui/material/Grid/Grid";
import { ChangeDecomalPoint } from '../../utils/SessionService';
// import { useEffect } from 'react';









function GameMission() {
  const { loginStore } = useStore();
  const { CoinStore } = useStore();
  const { MissionStore } = useStore();




  const PmgLevelData = JSON.parse(JSON.stringify(MissionStore.PmgMissionLevelInfo));
  let NowPmgLevelData = PmgLevelData[0];
  let NextPmgLevelData = PmgLevelData[1];
  let PmgToken = MissionStore?.PmgMissionCommission;
  let PmgGrade = MissionStore?.GradeMissionPmgCommission;
  let Pmgamount = ChangeDecomalPoint(PmgLevelData[1]?.amount_count, 10000000000);



  const CagLevelData = JSON.parse(JSON.stringify(MissionStore.CagMissionLevelInfo));
  let NowCagLevelData = CagLevelData[0];
  let NextCagLevelData = CagLevelData[1];
  let CagToken = MissionStore?.CagMissionCommission;
  let CagGrade = MissionStore?.GradeMissionCagCommission;
  let Cagamount = ChangeDecomalPoint(CagLevelData[1]?.amount_count, 10000000000);


  const GolfLevelData = JSON.parse(JSON.stringify(MissionStore.GolfMissionLevelInfo));
  let NowGolfLevelData = GolfLevelData[0];
  let NextGolfLevelData = GolfLevelData[1];
  let GolfToken = MissionStore?.GolfMissionCommission;
  let GolfGrade = MissionStore?.GradeMissionGolfCommission;
  let Golfamount =  ChangeDecomalPoint(GolfLevelData[1]?.amount_count, 10000000000);





  const MissionMemberState = MissionStore?.MissionLevelState;
  const GuideEtherCoin = CoinStore?.GuideEtherCoin;




  const AllLevel = MissionMemberState?.pmg_mission_level + MissionMemberState?.cag_mission_level + MissionMemberState?.golf_mission_level; //골프
  // const AllLevel = MissionMemberState?.pmg_mission_level + MissionMemberState?.cag_mission_level;


  // const PmgNowLevel = JSON.parse(JSON.stringify(MissionStore.PmgNowMissionLevel));
  // const CagNowLevel = JSON.parse(JSON.stringify(MissionStore.CagNowMissionLevel));


  // const navigate = useNavigate();

  const useStyles = makeStyles((theme) => ({
    //Dialog
    Dialog: {
      width: '440px',
      height: "600px"
    },
    DialogMobile: {
      height: '60%',
      width: '100%',
      minWidth: "320px",
    },
    //UserImage
    UserImage: {
      width: "40px",
      height: "40px"
    },
    UserImageMobile: {
      flex: 1,
      width: '100%',
      height: '100%',
      objectFit: 'contain'
    },

  }));


  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width: 600px)");
  // const isSm = useMediaQuery("(max-width: 900px)");
  const StandCount = CoinStore?.GuideStandCoin;
  // console.log(GuideEtherCoin);
  const isGameMissionDialogOpen = loginStore?.isGameMissionDialogOpen;



  // useEffect(() => {//유저 게임 정보 가져오기
  //   console.log("Start");
  //   async function UserGameMissionInfo() {
  //     await MissionStore.getUserMissionLevelInfo();
  //   }
  //   UserGameMissionInfo();
  //   // eslint-disable-next-line
  // }, [])

  const CountTypographyMobile = withStyles({
    root: isMobile ?
      {
        fontSize: '0.8rem',
      }
      :
      {
        fontSize: '0.9rem',
      }
  })(Typography);


  // const WhiteMissiomTextTypography = withStyles({
  //   root: isMobile ?
  //     {
  //       fontSize: '0.5rem',
  //       color: "#FFFFFF",
  //       fontWeight: 'bold',
  //     }
  //     :
  //     isSm ?
  //       {
  //         fontSize: '1rem',
  //         color: "#FFFFFF",
  //         fontWeight: 'bold'
  //       }
  //       :
  //       {
  //         fontSize: '1.5rem',
  //         color: "#FFFFFF",
  //         fontWeight: 'bold',
  //       }
  // })(Typography);



  const WhiteTextTypography = withStyles({
    root: {
      fontSize: "1.5rem",
      color: "#FFFFFF",
    }
  })(Typography);
  const CloverWhiteTextTypography = withStyles({
    root: {
      fontSize: "1rem",
      color: "#FFFFFF",
    }
  })(Typography);



  const GameWhiteTextTypography = withStyles({
    root: {
      fontSize: isMobile ? "1.5rem" : "2rem",
      color: "#FFFFFF",
    }
  })(Typography);


  let Guide_clover_dialog_GameMission_01 = loginStore?.Guide_clover_dialog_GameMission_01; //My.게임미션
  let Guide_clover_dialog_GameMission_02 = loginStore?.Guide_clover_dialog_GameMission_02; //MAX
  let ErrorGuide_clover_002 = loginStore?.ErrorGuide_clover_002; //MAX레벨에 도달 하셨습니다.




  return (
    <div>
      <Dialog classes={isMobile ? { paper: classes.DialogMobile } : { paper: classes.Dialog }} maxWidth="xl" open={isGameMissionDialogOpen} onClose={loginStore.setDialogClose}>
        <Box sx={{ display: 'flex', bgcolor: 'black', width: '100%', maxWidth: '600vw', height: '7vh', }}>
          <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='space-between' alignItems='center' >
            <Grid container item xs={11} sm={11} md={11} lg={11} xl={11} alignItems="flex-end"  >
              <img src={CloverleafImage} width="12%" height="auto" alt="Cloverleaf" />
              <WhiteTextTypography> {Guide_clover_dialog_GameMission_01}</WhiteTextTypography>
            </Grid>
            <Grid container item xs={1} sm={1} md={1} lg={1} xl={1}>
              <FontAwesomeIcon icon={faXmark} color='White' size='2x' onClick={(e) => { loginStore.setDialogClose("GameMissionFalse") }} />
            </Grid>
          </Grid>
        </Box>
        <DialogContent sx={{ padding: 0 }} >

          <Box sx={{ display: 'flex', bgcolor: 'white', width: '100%', maxWidth: '600vw', height: 'auto', boxShadow: "2px 4px 10px 1px rgba(201,201,201,0.47)" }}>
            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='space-between' alignItems='flex-start' >
              {MissionStore?.ErrorMissionGtade_01} {/*에러처리 */}
              {/* <Grid container item xs={11} sm={11} md={11} lg={11} xl={11} alignItems="flex-end"  >
              <img src={CloverleafImage} width="12%" height="auto" alt="Cloverleaf" />
              <WhiteTextTypography> {Guide_clover_dialog_GameMission_01}</WhiteTextTypography>
            </Grid>
            <Grid container item xs={1} sm={1} md={1} lg={1} xl={1}>
              <FontAwesomeIcon icon={faXmark} color='White' size='2x' onClick={(e) => { loginStore.setDialogClose("GameMissionFalse") }} />
            </Grid> */}
            </Grid>
          </Box>

          <Box sx={{ boxShadow: 5 }} >
            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent="space-between" alignItems='center'>

              <Grid item xs={2} sm={2} md={2} lg={2} xl={2} >
                <Box sx={isMobile ? { display: 'flex', border: 2, borderColor: '#e0e0e0', width: '30px', height: '30px', margin: 1 }
                  : { display: 'flex', border: 2, borderColor: '#e0e0e0', width: '40px', margin: 1 }}>
                  {loginStore?.loginState?.profile_image !== null ?
                    <img className={isMobile ? classes.UserImageMobile : classes.UserImage} src={`${process.env.REACT_APP_PROFILE_IMAGE_SERVER}${loginStore?.loginState?.profile_image}`} alt="UserImage" />
                    : <img className={isMobile ? classes.BasicUserImageMobile : classes.BasicUserImage} src={UserImage} alt="UserImage" />
                  }
                </Box>
              </Grid>

              <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='column' >
                  <Grid container item xs={5} sm={5} md={5} lg={5} xl={5} justifyContent='flex-start' alignItems='center' gap={0.5} >
                    <Grid container item xs={1} sm={1} md={1} justifyContent='flex-start' alignItems='center'>
                      <img style={{ width: '20px', height: "20px" }} src={DImage} alt="DImage" />
                    </Grid>
                    <Grid container item xs={5} sm={5} md={5} justifyContent='flex-start' alignItems='flex-end'>
                      <CountTypographyMobile  >
                        {StandCount !== undefined || StandCount !== null || StandCount !== "" ? StandCount : '0'}
                      </CountTypographyMobile>
                    </Grid>
                  </Grid>
                  <Grid container item xs={5} sm={5} md={5} lg={5} xl={5} justifyContent='flex-start' alignItems='center' gap={0.5}>
                    <Grid container item xs={1} sm={1} md={1} justifyContent='flex-start' alignItems='center'>
                      <img style={{ width: '20px', height: "20px" }} src={EthImage} alt="EthImage" />
                    </Grid>
                    <Grid container item xs={5} sm={5} md={5} justifyContent='flex-start' alignItems='flex-end'>
                      <CountTypographyMobile  >
                        {GuideEtherCoin}
                      </CountTypographyMobile>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container item xs={4} sm={4} md={4} lg={4} xl={4} fontSize={isMobile ? "2rem" : "3rem"} fontWeight='700' justifyContent='center' alignItems='center'>
                {AllLevel}.LV
              </Grid>
            </Grid>
          </Box>

          <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' paddingTop="3%" onClick={(e) => { MissionStore.UserMissionUpgradeTokenSend('pmg', { amount_count: Pmgamount, Token: PmgToken }) }}>
            <Box sx={isMobile ? { maxWidth: '100%', mx: 'auto', height: 'auto', width: '100%', boxShadow: 5 }
              : { maxWidth: '100%', mx: 'auto', height: '80%', width: '100%', boxShadow: 5 }} >
              <Grid container item style={{ position: 'relative' }} xs={12} sm={12} md={12} lg={12} xl={12} direction='row' alignItems='center' justifyContent='center' >
                <img id="Mission_One" style={{ width: "100%", height: "100%", margin: 0, padding: isMobile ? 2 : 2 }} src={PmgImage} alt="PmgImage" />
                <Grid container item style={{ position: "absolute" }} xs={12} sm={12} md={12} lg={12} xl={12} direction='column' alignItems='flex-end'>
                  <img id="Blind" style={{ width: "63%", height: "60%", margin: 0, padding: 0 }} src={Blind} alt="Blind" />

                  <Box style={{ position: "absolute", width: '50%', height: '100%', margin: 0, padding: 0, display: "grid" }} >

                    {
                      MissionStore?.isPmgMaxLevel === true ?

                        <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} margin={0} padding={0} direction='row' alignItems='center' gap={isMobile ? 0.5 : 1} >


                          <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center'>
                            <GameWhiteTextTypography>
                              {Guide_clover_dialog_GameMission_02}
                            </GameWhiteTextTypography>
                          </Grid>
                        </Grid>
                        :

                        <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} margin={0} padding={0} direction='row' alignItems='center' gap={isMobile ? 0.5 : 1} >

                          <Grid container item xs={5} sm={5} md={5} lg={5} xl={5} direction='column' justifyContent='space-between' alignItems='center' >
                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center'>
                              <GameWhiteTextTypography>
                                {NowPmgLevelData?.mission_level}.lv
                              </GameWhiteTextTypography>
                            </Grid>
                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='space-between' alignItems='center'>
                              <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                <img src={CloverleafImage} width="90%" height="auto" alt="Cloverleaf" />
                              </Grid>
                              <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                                <CloverWhiteTextTypography>
                                  {NowPmgLevelData?.reward_count}
                                </CloverWhiteTextTypography>
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={1} sm={1} md={1} lg={1} xl={1} >
                            <GameWhiteTextTypography>
                              {'>'}
                            </GameWhiteTextTypography>
                          </Grid>

                          <Grid container item xs={5} sm={5} md={5} lg={5} xl={5} direction='column' justifyContent='space-between' >
                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center'>
                              <GameWhiteTextTypography>
                                {NextPmgLevelData?.mission_level}.lv
                              </GameWhiteTextTypography>
                            </Grid>
                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='space-between' alignItems='center'>
                              <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                <img src={CloverleafImage} width="90%" height="auto" alt="Cloverleaf" />
                              </Grid>
                              <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                                <CloverWhiteTextTypography>
                                  {NextPmgLevelData?.reward_count}
                                </CloverWhiteTextTypography>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                    }
                  </Box>
                </Grid >
              </Grid >
              {MissionStore?.isPmgMaxLevel === true ?
                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' alignItems='center' justifyContent='flex-end' padding={1} >
                  {ErrorGuide_clover_002}
                </Grid>
                :
                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' alignItems='center' justifyContent='center' padding={1} >
                  <Grid item xs={1} sm={1} md={1} lg={1} xl={1} />
                  <Grid container item xs={5} sm={5} md={5} lg={5} xl={5}
                    direction='row' justifyContent="flex-end" alignItems="flex-end"
                    maxHeight="25%" paddingRight="5%"
                    fontSize={isMobile ? "0.7rem" : "1rem"}
                    // bgcolor="blueviolet"
                  >
                    <img style={{ width: '20px', height: "20px" }} src={DImage} alt="DImage" />
                    {Pmgamount !== null ? Pmgamount : "0"}
                  </Grid>
                  <Grid container item xs={6} sm={6} md={6} lg={6} xl={6}
                    direction='row' justifyContent="flex-end" alignItems='flex-end'
                    maxHeight="25%" paddingRight="5%"
                    fontSize={isMobile ? "0.7rem" : "1rem"}
                  // margin="0"
                  // padding="0"
                  // bgcolor="red"
                  >
                    <img style={{ width: '20px', height: "20px" }} src={EthImage} alt="EthImage" />
                    {PmgToken !== null ? PmgToken : PmgGrade}
                  </Grid>
                </Grid>
              }
            </Box>
          </Grid>


          <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' paddingTop="3%" onClick={(e) => { MissionStore.UserMissionUpgradeTokenSend('cag', { amount_count: Cagamount, Token: CagToken }) }}>
            <Box sx={isMobile ? { maxWidth: '100%', mx: 'auto', height: 'auto', width: '100%', boxShadow: 5 }
              : { maxWidth: '100%', mx: 'auto', height: '80%', width: '100%', boxShadow: 5 }} >
              <Grid container item style={{ position: 'relative' }} xs={12} sm={12} md={12} lg={12} xl={12} direction='row' alignItems='center' justifyContent='center' >
                <img id="Mission_One" style={{ width: "100%", height: "100%", margin: 0, padding: isMobile ? 2 : 2 }} src={CagImage} alt="CagImage" />
                <Grid container item style={{ position: "absolute" }} xs={12} sm={12} md={12} lg={12} xl={12} direction='column' alignItems='flex-end'>
                  <img id="Blind" style={{ width: "63%", height: "60%", margin: 0, padding: 0 }} src={Blind} alt="Blind" />

                  <Box style={{ position: "absolute", width: '50%', height: '100%', margin: 0, padding: 0, display: "grid" }} >
                    {MissionStore?.isCagMaxLevel === true ?
                      <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center'>
                        <GameWhiteTextTypography>
                          {Guide_clover_dialog_GameMission_02}
                        </GameWhiteTextTypography>
                      </Grid>
                      :
                      <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} margin={0} padding={0} direction='row' alignItems='center' gap={isMobile ? 0.5 : 1} >

                        <Grid container item xs={5} sm={5} md={5} lg={5} xl={5} direction='column' justifyContent='space-between' alignItems='center' >
                          <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center'>
                            <GameWhiteTextTypography>
                              {NowCagLevelData?.mission_level}.lv
                            </GameWhiteTextTypography>
                          </Grid>
                          <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='space-between' alignItems='center'>
                            <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                              <img src={CloverleafImage} width="90%" height="auto" alt="Cloverleaf" />
                            </Grid>
                            <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                              <CloverWhiteTextTypography>
                                {NowCagLevelData?.reward_count}
                              </CloverWhiteTextTypography>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1} >
                          <GameWhiteTextTypography>
                            {'>'}
                          </GameWhiteTextTypography>
                        </Grid>

                        <Grid container item xs={5} sm={5} md={5} lg={5} xl={5} direction='column' justifyContent='space-between'>
                          <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center'>
                            <GameWhiteTextTypography>
                              {NextCagLevelData?.mission_level}.lv
                            </GameWhiteTextTypography>
                          </Grid>
                          <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='space-between' alignItems='center'>
                            <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                              <img src={CloverleafImage} width="90%" height="auto" alt="Cloverleaf" />
                            </Grid>
                            <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                              <CloverWhiteTextTypography>
                                {NextCagLevelData?.reward_count}
                              </CloverWhiteTextTypography>
                            </Grid>
                          </Grid>
                        </Grid>


                      </Grid>
                    }
                  </Box>

                </Grid >
              </Grid >
              {MissionStore?.isCagMaxLevel === true ?
                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' alignItems='center' justifyContent='flex-end' padding={1} >
                  {ErrorGuide_clover_002}
                </Grid>
                :
                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' alignItems='center' justifyContent='center' padding={1} >
                  <Grid item xs={1} sm={1} md={1} lg={1} xl={1} />
                  <Grid container item xs={5} sm={5} md={5} lg={5} xl={5}
                    direction='row' justifyContent="flex-end" alignItems="flex-end"
                    maxHeight="25%" paddingRight="5%"
                    fontSize={isMobile ? "0.7rem" : "1rem"}
                  >
                    <img style={{ width: '20px', height: "20px" }} src={DImage} alt="DImage" />
                    {Cagamount !== null ? Cagamount : "0"}
                  </Grid>
                  <Grid container item xs={6} sm={6} md={6} lg={6} xl={6}
                    direction='row' justifyContent="flex-end" alignItems="flex-end"
                    maxHeight="25%" paddingRight="5%"
                    fontSize={isMobile ? "0.7rem" : "1rem"}
                  // margin="0"
                  // padding="0"
                  >
                    <img style={{ width: '20px', height: "20px" }} src={EthImage} alt="EthImage" />
                    {CagToken !== null ? CagToken : CagGrade}
                  </Grid>
                </Grid>
              }
            </Box>
          </Grid>

          {/*골프 */}
          <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' paddingTop="3%" onClick={(e) => {MissionStore.UserMissionUpgradeTokenSend('golf', {amount_count : Golfamount, Token: GolfToken})}}>
            <Box sx={isMobile ? { maxWidth: '100%', mx: 'auto', height: 'auto', width: '100%', boxShadow: 5 }
              : { maxWidth: '100%', mx: 'auto', height: '80%', width: '100%', boxShadow: 5 }} >
              <Grid container item style={{ position: 'relative' }} xs={12} sm={12} md={12} lg={12} xl={12} direction='row' alignItems='center' justifyContent='center' >
                <img id="Mission_One" style={{ width: "100%", height: "100%", margin: 0, padding: isMobile ? 2 : 2 }} src={GolfImage} alt="GolfImage" />
                <Grid container item style={{ position: "absolute" }} xs={12} sm={12} md={12} lg={12} xl={12} direction='column' alignItems='flex-end'>
                  <img id="Blind" style={{ width: "63%", height: "60%", margin: 0, padding: 0 }} src={Blind} alt="Blind" />

                  <Box style={{ position: "absolute", width: '50%', height: '100%', margin: 0, padding: 0, display: "grid" }} >
                    {MissionStore?.isGolfMaxLevel === true ?
                      <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center'>
                        <GameWhiteTextTypography>
                          {Guide_clover_dialog_GameMission_02}
                        </GameWhiteTextTypography>
                      </Grid>
                      :
                      <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} margin={0} padding={0} direction='row' alignItems='center' gap={isMobile ? 0.5 : 1} >

                        <Grid container item xs={5} sm={5} md={5} lg={5} xl={5} direction='column' justifyContent='space-between' alignItems='center' >
                          <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center'>
                            <GameWhiteTextTypography>
                              {NowGolfLevelData?.mission_level}.lv
                            </GameWhiteTextTypography>
                          </Grid>
                          <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='space-between' alignItems='center'>
                            <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                              <img src={CloverleafImage} width="90%" height="auto" alt="Cloverleaf" />
                            </Grid>
                            <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                              <CloverWhiteTextTypography>
                                {NowGolfLevelData?.reward_count}
                              </CloverWhiteTextTypography>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1} >
                          <GameWhiteTextTypography>
                            {'>'}
                          </GameWhiteTextTypography>
                        </Grid>

                        <Grid container item xs={5} sm={5} md={5} lg={5} xl={5} direction='column' justifyContent='space-between'>
                          <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center'>
                            <GameWhiteTextTypography>
                              {NextGolfLevelData?.mission_level}.lv
                            </GameWhiteTextTypography>
                          </Grid>
                          <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='space-between' alignItems='center'>
                            <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                              <img src={CloverleafImage} width="90%" height="auto" alt="Cloverleaf" />
                            </Grid>
                            <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                              <CloverWhiteTextTypography>
                                {NextGolfLevelData?.reward_count}
                              </CloverWhiteTextTypography>
                            </Grid>
                          </Grid>
                        </Grid>


                      </Grid>
                    }
                  </Box>

                </Grid >
              </Grid >
              {MissionStore?.isGolfMaxLevel === true ?
                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' alignItems='center' justifyContent='flex-end' padding={1} >
                  {ErrorGuide_clover_002 }
                </Grid>
                :
                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' alignItems='center' justifyContent='center' padding={1} >
                  <Grid item xs={1} sm={1} md={1} lg={1} xl={1} />
                  <Grid container item xs={5} sm={5} md={5} lg={5} xl={5}
                    direction='row' justifyContent="flex-end" alignItems="flex-end"
                    maxHeight="25%" paddingRight="5%"
                    fontSize={isMobile ? "0.7rem" : "1rem"}
                  >
                    <img style={{ width: '20px', height: "20px" }} src={DImage} alt="DImage" />
                    {Golfamount !== null ? Golfamount : "0"}
                  </Grid>
                  <Grid container item xs={6} sm={6} md={6} lg={6} xl={6}
                    direction='row' justifyContent="flex-end" alignItems="flex-end"
                    maxHeight="25%" paddingRight="5%"
                    fontSize={isMobile ? "0.7rem" : "1rem"}
                    // margin="0"
                    // padding="0"
                  >
                    <img style={{ width: '20px', height: "20px" }} src={EthImage} alt="EthImage" />
                    {GolfToken !== null ? GolfToken : GolfGrade }
                  </Grid>
                </Grid>
              }
            </Box>
          </Grid>



        </DialogContent>
      </Dialog>
    </div>
  );
};

export default observer(GameMission);